import React from "react"
import PropTypes from "prop-types"

const findMatch = (colours, thumbs) => {
	const matches = colours.filter(match => thumbs.includes(match))
	return matches[0]
}

const renderImage = (hit, colour) => {
    
	if (hit.thumbnails && Object.keys(hit.thumbnails).length) {
		if (!colour) {
			return <img src={hit.thumbnails[Object.keys(hit.thumbnails)[0]]} width="210" height="210" alt={hit.title} />
		}
		return <img src={hit.thumbnails[findMatch(colour, Object.keys(hit.thumbnails))]} width="210" height="210" alt={hit.title} />
	}
	return <div className="thumbnail__placeholder" />
}
const renderColor =   (hit) => {
	var labelImage = [];
	if( hit.productLabel && hit.productLabel != null)
	{
		var productLbls = Object.values(hit.productLabel);
		if(productLbls != null)
		{
			var count = 1;
			for (const prodLabel of productLbls) {
				var backgroundStyle = "";
				var labelClass = "prod-label"+count;
				count++;
				if(count > 2)
				{
					break;
				}
				if(  prodLabel.image)
				{
					backgroundStyle =   { "background":"url('"+prodLabel.image+"')"};
				}
				else if( prodLabel.color)
				{
					backgroundStyle =   { "background":prodLabel.color};
				}
				if ( prodLabel.font )
				{
					labelClass = labelClass + " "+prodLabel.font;
				}
				
				
				if(backgroundStyle != "")
				{
					  labelImage.push(<span className={labelClass+" productLabel "} style={backgroundStyle}  > {prodLabel.label} </span>); 
				}
			  }
		}
	}
	return labelImage;

}
 function Hit({ hit, colour }){
   return (<a href={hit.absoluteUri} className="thumbnail">
		 {renderColor(hit)}
        {renderImage(hit, colour)}
        {hit.title}
    </a> )
 }
Hit.propTypes = {
		hit: PropTypes.shape({
		image: PropTypes.arrayOf(PropTypes.object),
		title: PropTypes.string,
		absoluteUri: PropTypes.string,
	})
};
export default Hit